module.exports = __webpack_public_path__ + "static/media/Products (7).492787eb.jpg";